import Export, { REPORT_TYPES } from "Export";
import React from "react";

const getMarcGenerationUrl = orgId =>
  `${process.env.REACT_APP_CATALOG_BASE_URL}/marc/organizations/${orgId}`;

const MarcExport = () => {
  return (
    <Export
      reportType={REPORT_TYPES.MARC}
      getExportGenerationUrl={getMarcGenerationUrl}
    />
  );
};

export default MarcExport;
